import axios from 'axios';
import Swal from 'sweetalert2';
import { logoutUser } from './store/slices/authSlice';

let getStore = null;
export const setStore = (storeInstance) => {
  getStore = () => storeInstance;
};

const api = axios.create({
  baseURL: 'https://trh-backend.clouxiplexi.com/api',
  headers: { 'Content-Type': 'application/json' },
});

// 🔒 Global lock to prevent multiple modals
let unauthorizedHandled = null;

api.interceptors.request.use(
  (config) => {
    if (getStore) {
      const { auth } = getStore().getState();
      const token = auth?.token;
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url; 

    // 401: Unauthorized (Token Expired)
    // Ignore 401s from the login page itself (wrong password)
    if (status === 401 && getStore && !requestUrl.includes('/login')) {

      // ✅ Lock handling
      if (unauthorizedHandled) {
        await unauthorizedHandled;
        return Promise.reject(error);
      }

      unauthorizedHandled = (async () => {
        try {
          // 1. Check if the "Session" flag exists
          // It only exists if the tab was kept open since login.
          // It is NULL if the browser was closed and reopened.
          const isTabOpen = sessionStorage.getItem('is_active_session');

          let title = 'Session Expired';
          let text = 'Your session has expired. Please log in again.';

          // 2. Change message if flag is missing (Browser was closed)
          if (!isTabOpen) {
             text = "Due to inactivity for 2 hours you've been logged out. Please log in again to continue.";
          }

          // 3. Dispatch Logout
          getStore().dispatch(logoutUser());

          // 4. Clear the flag explicitly (cleanup)
          sessionStorage.removeItem('is_active_session');

          await Swal.fire({
            icon: 'warning',
            title: title,
            text: text,
            confirmButtonText: 'Login',
            allowOutsideClick: false,
            allowEscapeKey: false,
          });

          // 5. Redirect
          window.location.replace('/login');
        } finally {
          unauthorizedHandled = null;
        }
      })();

      await unauthorizedHandled;
    }

    return Promise.reject(error);
  }
);

export default api;